/** The month's content plan: a couple posted, one scheduled, two in draft. */

import type { ContentItem } from '../../services/contentPlanService';
import { DEMO_WEBSITE_ID } from './site';
import { dayKey, daysAgo } from './time';

export const demoContentItems: ContentItem[] = [
  {
    id: 'demo-content-1',
    websiteId: DEMO_WEBSITE_ID,
    type: 'blog',
    title: 'How to shut your water off before the plumber arrives',
    content:
      'A short guide for Madison homeowners: where the main shut-off usually sits in houses built before 1960, how to tell a stuck valve from a seized one, and what to do if the handle snaps. Written to be the page someone finds at 11pm with water on the floor.',
    scheduledDate: dayKey(-6),
    status: 'posted',
    platform: ['website'],
    keywords: ['water shut off valve', 'emergency plumber madison'],
    action: null,
    createdAt: daysAgo(12),
    updatedAt: daysAgo(6),
  },
  {
    id: 'demo-content-2',
    websiteId: DEMO_WEBSITE_ID,
    type: 'social',
    title: 'Before and after: 1948 basement repipe',
    content:
      'Three photos from the Ridgway job — galvanised out, PEX in, and the finished manifold. Caption names the neighbourhood and the crew.',
    scheduledDate: dayKey(-2),
    status: 'posted',
    platform: ['facebook', 'instagram'],
    keywords: ['repipe', 'madison plumber'],
    action: null,
    createdAt: daysAgo(9),
    updatedAt: daysAgo(2),
  },
  {
    id: 'demo-content-3',
    websiteId: DEMO_WEBSITE_ID,
    type: 'blog',
    title: 'What a water heater replacement actually costs in Dane County',
    content:
      'Honest price bands for 40 and 50 gallon gas units, what drives the difference (venting, expansion tank, code updates), and when a repair is still the better call.',
    scheduledDate: dayKey(4),
    status: 'scheduled',
    platform: ['website'],
    keywords: ['water heater replacement cost', 'water heater madison wi'],
    action: null,
    createdAt: daysAgo(5),
    updatedAt: daysAgo(3),
  },
  {
    id: 'demo-content-4',
    websiteId: DEMO_WEBSITE_ID,
    type: 'faq',
    title: 'Do you charge for after-hours calls?',
    content: 'Answer the emergency-rate question plainly on the site so nobody has to ring to find out.',
    scheduledDate: null,
    status: 'draft',
    platform: ['website'],
    keywords: ['after hours plumber', 'emergency rates'],
    action: 'Confirm the current after-hours rate before this goes live.',
    createdAt: daysAgo(4),
    updatedAt: daysAgo(4),
  },
  {
    id: 'demo-content-5',
    websiteId: DEMO_WEBSITE_ID,
    type: 'gallery',
    title: 'Add five job photos from the last month',
    content: 'Sump pump swap, the spigot repair and the Ridgway rough-in. Real photos beat stock on every service page.',
    scheduledDate: null,
    status: 'draft',
    platform: ['website'],
    keywords: [],
    action: 'Send photos from your phone.',
    createdAt: daysAgo(3),
    updatedAt: daysAgo(3),
  },
];
